export const UPDATE_AUTH = 'UPDATE_AUTH';
export const updateAuth = (data) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_AUTH,
                data: data,
            }),
        );
    };
};
